export default "__VITE_ASSET__U0k2CcKe__"